module.exports = __webpack_public_path__ + "static/img/12.b4be95a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/8/1/zh/12.png
// module id = 2krJ
// module chunks = 0